import React, { Component } from "react";
import { GoogleApiWrapper, InfoWindow, Map, Marker } from "google-maps-react";
import { fire } from "../Firebase/firebase";
import parkIcon from "../../../src/img/parkIcon.png";
import dogIcon from "../../../src/img/dogIcon.png";

export class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      markers: [],
      userMarkers: [],
      isLoading: true
    };
  }

// When component mounts and the users location is defined, fetch places.json and map the response into marker objects. 
// Then set the state of markers to an array of these objects
  componentDidMount() {
    if (this.props.myLatLng !== undefined) {
      // Get dog markers
      fetch("./places.json")
        .then(response => response.json())
        .then(parsedJSON =>
          parsedJSON.results.map(marker => ({
            name: `${marker.name}`,
            lng: `${marker.geometry.location.lng}`,
            lat: `${marker.geometry.location.lat}`,
            key: `${marker.id}`
          }))
        )
        .then(markers =>
          this.setState({
            markers,
            isLoading: false
          })
        )
        .catch(error => console.log("parsing failed", error));
    } else console.log("MY LATLNG UNDEFINED");

//First update the coordinates of the  current user, then in callback get markers
    this.upDateUserCoords(this.getUserMarkers.bind(this));
// Periodically update user markers 
    this.intervalId = setInterval(this.upDateUserMarkers.bind(this), 10000);
  }


  upDateUserCoords(callback) {
    let uid = fire.auth().currentUser.uid;
// Get position from browser, set coords of user in database with a timestamp. Then Call getUserMarkers
    navigator.geolocation.watchPosition(function(position) {
      fire
        .database()
        .ref("users")
        .child(uid)
        .update({
          coords: {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          },
          timestamp: Math.floor(Date.now() / 1000)
        });
    }, callback());
  }

//Go through all users in the firebase ref, create markers if user has marked themselves visible
  getUserMarkers() {
    var query = fire
      .database()
      .ref("users")
      .orderByKey();
    query.once("value").then(snapshot => {
      snapshot.forEach((childSnapshot, data) => {
        const key = childSnapshot.key;
        const childData = childSnapshot.val();
        if (
          childData.coords.latitude != null &&
          childData.coords.longitude &&
          childData.visibility === true
        ) {
          const marker = {
            key: key,
            lat: childData.coords.latitude,
            lng: childData.coords.longitude,
            name: childData.name
          };
          this.setState({ userMarkers: [...this.state.userMarkers, marker] });
        } else {
          console.log("Cannot read property or user is not visible");
        }
      });
    });
  }

// upDate markers, executed periodically
  upDateUserMarkers() {
    var query = fire.database().ref("users");

    let i = 0;
    query.once("value").then(snapshot => {
      snapshot.forEach((childSnapshot, data) => {
        const key = childSnapshot.key;
        const childData = childSnapshot.val();

        if (childData.coords && childData.visibility === true) {
          const marker = {
            key: key,
            lat: childData.coords.latitude,
            lng: childData.coords.longitude,
            name: childData.name
          };

          this.state.userMarkers[i] = marker;
          this.setState({ userMarkers: this.state.userMarkers });

          i++;
        }
      });
    });
  }

  onMarkerClick = (props, marker, e) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  };

  onMapClick = props => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      });
    }
  };

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  render() {
    const style = {
      width: "100vw",
      height:"100vh",
      zIndex: 0
    };
    
    //map two arrays of markers onto the map
    // <a href="https://www.freepik.com/free-photos-vectors/dog">Dog vector created by freepik - www.freepik.com</a>
    return (
      <Map
        item
        xs={12}
        style={style}
        google={this.props.google}
        onClick={this.onMapClick}
        zoom={11}
        initialCenter={{
          lat: this.props.myLatLng.lat,
          lng: this.props.myLatLng.lng
        }}
        gestureHandling="greedy"
        onReady={this.handleMapMount}
      >
        {this.state.markers.map(marker => (
          <Marker
            key={marker.key}
            position={{ lat: marker.lat, lng: marker.lng }}
            title={marker.name}
            onClick={this.onMarkerClick}
            icon={parkIcon}
          />
        ))}
        {this.state.userMarkers.map(marker => (
          <Marker
            key={marker.key}
            position={{ lat: marker.lat, lng: marker.lng }}
            title={marker.name}
            icon={dogIcon}
            onClick={this.onMarkerClick}
          />
        ))}
        <InfoWindow
          marker={this.state.activeMarker}
          visible={this.state.showingInfoWindow}
        >
          <h1 id="infoWindow">{this.state.selectedPlace.title} </h1>

        </InfoWindow>
        {this.props.children}
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyCN_4lB6eOHnPmCip7Wpb4yjmjfO3sQMr8"
})(MapContainer);
